import { Cancel } from './cancel'
import { SearchResults } from './search-results'
import { SearchResultsAlt } from './search-results-alt'

export const IMAGES = {
  cancel: Cancel,
  searchResults: SearchResults,
  searchResultsAlt: SearchResultsAlt,
}

export type ImageName = keyof typeof IMAGES
